import { render, staticRenderFns } from "./border.vue?vue&type=template&id=7a65144f&"
import script from "./border.vue?vue&type=script&lang=js&"
export * from "./border.vue?vue&type=script&lang=js&"
import style0 from "./border.vue?vue&type=style&index=0&id=7a65144f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports